export default "__VITE_ASSET__DX$tFCyl__"